import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import FadeIn from "../components/Animation/FadeIn";
import IFSwiper from "../components/IF_Swiper";
import IFHeading from "../components/IF_Heading";
import { getManagement, getManagementCache } from "../services";

function SafeJsonParse(str, fallback = []) {
    try {
        return JSON.parse(str);
    } catch {
        return fallback;
    }
}

export default function Gymmanagement() {
    const cached = getManagementCache();
    const [data, setDatas] = useState(() => cached || { datas: [], album: [] });
    const [load, setLoad] = useState(() => !cached || !cached.datas || cached.datas.length === 0);

    useEffect(() => {
        getManagement(true).then((res) => {
            if (res && res.datas && res.datas.length > 0) {
                setDatas(res);
            }
            setLoad(false);
        });
    }, []);

    if (load || !data.datas || data.datas.length === 0) {
        return (
            <div className="min-h-[70vh] w-full flex items-center justify-center">
                <div className="w-12 h-12 rounded-full border-4 border-white/20 border-t-pink animate-spin" />
            </div>
        );
    }

    const clients = SafeJsonParse(data.datas[2]?.value, []);

    return (
        <div className="flex flex-col w-full overflow-x-hidden">
            {/* Hero Section */}
            <section className="pt-[130px] lg:pt-[160px] pb-10 md:pb-16 relative overflow-hidden">
                <div className="max-w-[1100px] mx-auto px-6">
                    <FadeIn duration={0.9}>
                        <div className="p-6 md:p-10 rounded-3xl bg-[#12141e] border border-pink/25 text-center">
                            <h1 className="text-2xl sm:text-3xl md:text-5xl font-black bg-gradient-to-r from-white to-pink bg-clip-text text-transparent mb-4 uppercase tracking-tight">
                                {data.datas[0]?.value}
                            </h1>
                            <p className="whitespace-pre-line text-sm md:text-base lg:text-lg text-gray-300 leading-relaxed max-w-[900px] mx-auto">
                                {data.datas[1]?.value}
                            </p>
                        </div>
                    </FadeIn>
                </div>
            </section>

            {/* Clients Section */}
            <section className="py-10 md:py-16 px-4 md:px-8">
                <IFHeading>OUR CLIENTS</IFHeading>

                <div className="max-w-[1300px] mx-auto mt-8">
                    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4 md:gap-6">
                        {clients.map((d, idx) => (
                            <motion.div
                                key={d.image || idx}
                                initial={{ opacity: 0, y: 25 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true }}
                                transition={{ duration: 0.8, delay: idx * 0.08, ease: "linear" }}
                                whileHover={{ y: -6 }}
                                className="h-full"
                            >
                                <div className="h-full p-4 rounded-2xl bg-[#12141e] border border-white/10 hover:border-pink transition-colors duration-200 flex flex-col items-center justify-between">
                                    <div
                                        className="w-full h-[90px] md:h-[110px] rounded-xl p-3 flex items-center justify-center overflow-hidden"
                                        style={{
                                            backgroundColor: d.background || "rgba(255, 255, 255, 0.05)",
                                            border: d.background ? `2px solid ${d.background}` : "none",
                                        }}
                                    >
                                        <img
                                            className="object-contain max-w-full max-h-full"
                                            src={process.env.REACT_APP_IMAGE_URL + d.image}
                                            alt={d.title || "Client"}
                                            loading="lazy"
                                        />
                                    </div>
                                    <span className="text-xs font-bold text-gray-300 text-center mt-3 line-clamp-2">
                                        {d.title}
                                    </span>
                                </div>
                            </motion.div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Album Swiper */}
            <IFSwiper data={data.album} />
        </div>
    );
}
